import { z } from 'zod';

export const userIdeaTypeSchema = z.enum(['mods', 'maps', 'clips', 'game_tools', 'new_feature', 'other']);
export type UserIdeaType = z.infer<typeof userIdeaTypeSchema>;
export type GameIdeaType = Exclude<UserIdeaType, 'new_feature'>;
export const userIdeaApplicationAreaSchema = z.enum([
    'wand_app',
    'overlay',
    'remote',
    'maps',
    'video_clipping',
    'game_tools',
    'community',
    'game_guide',
    'other',
]);
export type UserIdeaApplicationArea = z.infer<typeof userIdeaApplicationAreaSchema>;

export const userIdeaSchema = z
    .object({
        id: z.number().int(),
        type: userIdeaTypeSchema,
        idea: z.string(),
        displayText: z.string(),
        details: z.string().nullable(),
        displayDetails: z.string().nullable().optional(),
        gameId: z.number().int().nullable(),
        scopeType: z.enum(['game', 'application']).optional(),
        applicationArea: userIdeaApplicationAreaSchema.nullable().optional(),
        completedAt: z.string().nullable().optional(),
        game: z
            .object({
                titleId: z.string(),
                name: z.string(),
                thumbnail: z.string().nullable(),
            })
            .nullable()
            .optional(),
        status: z.enum(['pending', 'processing', 'needs_review', 'approved', 'rejected', 'duplicate', 'completed']),
        boosts: z.number().int().nonnegative(),
        isOwn: z.boolean(),
        creatorAvatarUrl: z.string().nullable(),
        creatorUsername: z.string().nullable(),
        rejectionReason: z.string().nullable(),
        duplicateOfId: z.number().int().nullable(),
    })
    .describe('UserIdea');
export type UserIdea = z.infer<typeof userIdeaSchema>;

export const userIdeaPageSchema = z
    .object({
        ideas: z.array(userIdeaSchema),
        nextOffset: z.number().int().nonnegative().nullable(),
    })
    .describe('UserIdeaPage');
export type UserIdeaPage = z.infer<typeof userIdeaPageSchema>;

export const userIdeaResponseSchema = z.object({ idea: userIdeaSchema }).describe('UserIdeaResponse');
export const relatedUserIdeasSchema = z.object({ related: z.array(userIdeaSchema) }).describe('RelatedUserIdeas');

export const userIdeaMutationSchema = z
    .object({
        idea: userIdeaSchema,
        remainingBoosts: z.number().int().nonnegative(),
    })
    .describe('UserIdeaMutation');
export type UserIdeaMutation = z.infer<typeof userIdeaMutationSchema>;

export interface UserIdeaFilters {
    readonly sort: 'top' | 'new';
    readonly type?: UserIdeaType;
    readonly status?: 'completed';
    readonly search?: string;
    readonly filter?: 'mine' | 'boosted';
    readonly gameIds?: readonly string[];
}
